import React, { useState } from 'react';
import { Button } from 'framework/ui/mui-builder';
import { Modal } from 'framework/ui/ui-builder';
import { useShowContext } from 'framework/show';
import { DELETE, UPDATE } from 'domain/shared/core/permissions';
import useLeadService, { LEAD_GRADE, CONVERT_LEAD } from 'domain/sales/lead/shared/leadService';
import { useMessageService, SuccessMessage, ErrorMessage } from 'framework/ui/Message';
import { useAuthorization } from 'framework/authorization';

const disqualificationParams = {
  status: 'DISQUALIFIED',
  disqualificationReason: 'SPAM',
  grade: LEAD_GRADE.D.alias,
};

const statusesForDisqualification = ['OPEN', 'NEW'];

const disqualificationMessage = 'The Lead has been disqualified.';

const MarkAsSpamButton = () => {
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const { data: lead, setData: updateLeadData = () => {} } = useShowContext();
  const { update } = useLeadService();
  const { isGranted } = useAuthorization();
  const { addMessage } = useMessageService();

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const disqualify = async (id: StringOrNumber) => {
    setLoading(true);

    try {
      const data: any = await update(id, {
        ...lead.getData(),
        ...disqualificationParams,
      });

      updateLeadData(data && data);

      setLoading(false);

      addMessage(new SuccessMessage(disqualificationMessage));
    } catch (error) {
      setLoading(false);
      addMessage(new ErrorMessage("Can't disqualify lead."));
    }
  };

  const shouldRenderSpamButton =
    lead &&
    lead.getValueBySource('disqualificationReason') !== 'SPAM' &&
    statusesForDisqualification.some(item => item === lead.getValueBySource('status')) &&
    (isGranted(CONVERT_LEAD) || isGranted(UPDATE) || isGranted(DELETE));

  const disqualifyBtn = (
    <Button
      color="primary"
      key="disqualifyBtn"
      onClick={async () => {
        closeModal();
        await disqualify(lead.getValueBySource('id'));
      }}
    >
      Disqualify lead
    </Button>
  );

  return shouldRenderSpamButton ? (
    <>
      <Button
        sx={{ ml: 1 }}
        color="error"
        variant="outlined"
        onClick={() => {
          openModal();
        }}
        disabled={loading}
      >
        SPAM
      </Button>

      <Modal isOpen={modalOpen} title="Are you sure?" onToggle={closeModal} buttons={[disqualifyBtn]}>
        <span>Do you really want to disqualify this lead?</span>
      </Modal>
    </>
  ) : null;
};

export default MarkAsSpamButton;
